module.exports = __webpack_public_path__ + "static/img/modeling5.9f2db44.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/modeling5.png
// module id = m+2+
// module chunks = 2